import { useMemo } from "react";
import { useParams, useOutlet, useNavigate } from "react-router";
import { Drawer } from "antd";
import {
  useAppContext,
  resolveViewComponent,
  ViewProvider,
  useNavigation,
} from "@data-root/react";

export const ViewScreen = () => {
  const navigate = useNavigate();
  const outlet = useOutlet();
  const { viewId } = useParams();

  const { navigation } = useNavigation();
  const { getView } = useAppContext();

  const view = useMemo(() => getView(viewId), [getView, viewId]);

  const Component = useMemo(() => resolveViewComponent(view.type), [view]);

  return (
    <>
    <ViewProvider view={view}>
      <Component view={view} />
    </ViewProvider>
      <Drawer
        open={!!outlet}
        width={500}
        onClose={() => {
          if (navigation.canGoBack()) navigation.goBack();
          else navigate("..");
        }}
      >
        {outlet}
      </Drawer>
    </>
  );
};
